import { useMutation } from "@tanstack/react-query";
import { useRef } from "react";

import {
  verifyCiLog,
  type CiLogConnectionBody,
  type CiLogVerifyResult,
} from "./ciLogsApi";

// «Проверить» без записи. Ответ, пришедший после правки полей формы,
// относится к уже изменённым значениям и игнорируется.

export interface CiLogVerify {
  readonly mutate: (body: CiLogConnectionBody) => void;
  readonly isPending: boolean;
  /** Вызывать при каждой правке поля: ответы в пути устаревают. */
  readonly markEdited: () => void;
}

export function useCiLogVerify(handlers: {
  readonly onAccepted: (result: CiLogVerifyResult) => void;
  readonly onRejected: (error: Error) => void;
}): CiLogVerify {
  const revision = useRef(0);

  const mutation = useMutation<
    CiLogVerifyResult,
    Error,
    CiLogConnectionBody,
    number
  >({
    mutationFn: (body) => verifyCiLog(body),
    onMutate: () => revision.current,
    onSuccess: (data, _variables, sentRevision) => {
      if (sentRevision === revision.current) {
        handlers.onAccepted(data);
      }
    },
    onError: (err, _variables, sentRevision) => {
      if (sentRevision === revision.current) {
        handlers.onRejected(err);
      }
    },
  });

  return {
    mutate: mutation.mutate,
    isPending: mutation.isPending,
    markEdited: () => {
      revision.current += 1;
    },
  };
}
